import { useEffect, useRef, useState } from 'react'

import AudioMediaRecorder from 'audio-recorder-polyfill'

import { randomString } from 'helpers/util'

export const useAudioRecorder = () => {
    const [recording, setRecording] = useState(false)
    const [audioURL, setAudioURL] = useState('')
    const mediaRecorderRef = useRef<MediaRecorder | null>(null)
    const audioChunks = useRef<Blob[]>([])
    const [audioFile, setAudioFile] = useState<File | null>(null)

    const AUDIO_RECORDING_ENABLED = false

    const startRecording = async () => {
        if (!AUDIO_RECORDING_ENABLED) return

        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true,
                video: false
            })

            mediaRecorderRef.current = new AudioMediaRecorder(stream)

            mediaRecorderRef.current?.addEventListener(
                'dataavailable',
                handleDataAvailable
            )

            mediaRecorderRef.current?.start()

            setRecording(true)
        } catch (error) {
            console.error('Error starting recording:', error)
        }
    }

    const stopRecording = () => {
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop()
            setRecording(false)
        }
    }

    const handleDataAvailable = (e: BlobEvent) => {
        audioChunks.current.push(e.data)
        if (!recording) {
            const blob = new Blob(audioChunks.current, { type: 'audio/mpeg-3' })
            const file = new File([blob], randomString(blob.type), {
                type: blob.type
            })
            setAudioFile(file)

            const url = URL.createObjectURL(blob)
            setAudioURL(url)
            audioChunks.current = []
        }
    }

    useEffect(() => {
        return () => {
            if (
                mediaRecorderRef.current &&
                mediaRecorderRef.current.state === 'recording'
            ) {
                stopRecording()
            }
        }
    }, [])

    return { startRecording, stopRecording, recording, audioURL, audioFile }
}
